import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserPageTitle } from '../shared/constants/browser-page-title.enum';

import {
  makePaymentsGuard,
  paymentsDashboardGuard,
  paymentsGuard,
} from './guards/payments.guard';
import { PaymentsPage } from './payments.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentsPage,
    data: { title: BrowserPageTitle.payments },
    canMatch: [paymentsGuard],
  },
  {
    path: 'all-invoices',
    loadChildren: () =>
      import('./pages/all-invoices/all-invoices.module').then(
        m => m.AllInvoicesPageModule,
      ),
  },
  {
    path: 'make-payment',
    loadChildren: () =>
      import('./pages/make-payment/make-payment.module').then(
        m => m.MakePaymentPageModule,
      ),
    canMatch: [makePaymentsGuard],
  },
  {
    path: 'payment-activity',
    loadChildren: () =>
      import('./pages/payment-activity/payment-activity.module').then(
        m => m.PaymentActivityPageModule,
      ),
  },
  {
    path: 'payment-preferences',
    loadChildren: () =>
      import('./pages/payment-preferences/payment-preferences.module').then(
        m => m.PaymentPreferencesPageModule,
      ),
    canMatch: [makePaymentsGuard],
  },
  {
    path: 'payment-dashboard',
    loadChildren: () =>
      import('./pages/payment-dashboard/payment-dashboard.module').then(
        m => m.PaymentDashboardPageModule,
      ),
    canMatch: [paymentsDashboardGuard],
  },
  {
    path: 'statements',
    loadChildren: () =>
      import('./pages/ar-statements/ar-statements.module').then(
        m => m.ARStatementsPageModule,
      ),
  },
  {
    path: 'autopay-setup-form-retrieval',
    loadChildren: () =>
      import('./pages/ach-form-retrieval/ach-form-retrieval.module').then(
        m => m.AchFormRetrievalPageModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentsPageRoutingModule {}
